module.exports = __webpack_public_path__ + "static/media/umglogo.48114510.png";